// src/pages/AuthCallback.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseClient } from '@supabase/auth-helpers-react';
import ResetPassword from '../components/ResetPassword'; // 引入 ResetPassword 組件

export default function AuthCallback() {
  const navigate = useNavigate();
  const supabaseClient = useSupabaseClient();
  
  // ✨ 【【【核心修正】】】 ✨
  // 1. 增加一個本地狀態來決定是否顯示重設表單
  const [isRecovery, setIsRecovery] = useState(false);

  useEffect(() => {
    // 2. 在組件掛載時，立即同步檢查 URL hash
    //    這是最直接、最可靠的方法
    if (window.location.hash.includes('type=recovery')) {
      setIsRecovery(true);
    }

    const { data: { subscription } } = supabaseClient.auth.onAuthStateChange((event, session) => {
      if (event !== 'PASSWORD_RECOVERY' && session) {
        console.log('AuthCallback: Detected login/signup event. Navigating to /introduction.');
        subscription.unsubscribe();
        navigate('/introduction');
      }
      // 我們不再需要特別處理 PASSWORD_RECOVERY 事件，因為 URL hash 檢查已經處理了
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [supabaseClient, navigate]);

  // 密碼更新成功後的回調函數
  const handlePasswordUpdated = () => {
    // 直接導航到 profile 頁面，並替換當前歷史記錄
    navigate('/profile', { replace: true });
  };

  // 3. 根據本地狀態決定渲染什麼
  if (isRecovery) {
    // 如果是密碼恢復流程，直接在此頁面渲染 ResetPassword 組件
    return <ResetPassword onPasswordUpdated={handlePasswordUpdated} />;
  }

  // 對於所有其他情況（登入、註冊），顯示加載指示器
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontSize: '1.5rem',
      fontWeight: 'bold'
    }}>
      Verifying authentication...
    </div>
  );
}